import cn from 'classnames';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Column, ImagesViewer } from '../../../../components/Basic/Blocks/index.js';
import { AnimateArrow, Button, ButtonWithTooltip } from '../../../../components/Basic/Buttons/index.js';
import { TableCell, TableLine } from '../../../../components/Basic/Table/index.js';
import { Text, TextGrey } from '../../../../components/Basic/WrapsStyle/index.js';
import PenaltyPopUp from '../../../../components/Shipments/Blocks/PenaltyPopUp/index.js';
import { TO_PRODUCT, TO_RESERVE, TYPE_BUTTONS } from '../../../../constans/index.js';
import { formFullDate } from '../../../../utils/index.js';
import CommentPostingProductBlock from '../../../Shipments/Posting/CommentBlock/index.js';
import WarehouseHistoryBlock from '../../../Warehouse/WarehouseProducts/ProductHistory/Content/index.js';
import { WIDTH_POSTING } from '../index.js';
import styles from './styles.module.scss';

const ReservesLine = ({ product = {}, width = [], onChange = () => { }, isAdmin = false, ...props }) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [isOpenHistory, setIsOpenHistory] = useState(false);

  const [images, setImages] = useState([]);
  const [openSklad, setOpenSklad] = useState({ state: false, product: {}, productProvider: {} });

  const [info, setInfo] = useState(false);
  const dispatch = useDispatch();

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  useEffect(() => {
    setIsOpenHistory(false);
  }, [product.warehouse_id]);

  return (
    <>
      <TableLine key={product._id}>
        <TableCell width={width[9]}>{<ImagesViewer images={[product.image || '']} />}</TableCell>
        <TableCell width={width[7]}>
          <div className={styles.block}>
            <Column>
              {product.warehouse_id}
              <TextGrey fontSize={12}>{formFullDate(product.date_create)}</TextGrey>
            </Column>

            <ButtonWithTooltip
              tooltip={isOpenHistory ? 'Скрыть историю изменений' : 'Показать историю изменений'}
              onClick={() => setIsOpenHistory(!isOpenHistory)}
            >
              <AnimateArrow isOpen={isOpenHistory} styles={cn(styles.open_icon_arrow)} />
            </ButtonWithTooltip>
          </div>
        </TableCell>
        <TableCell width={width[9]} center>
          <a href={TO_RESERVE(product.reserve_id)} target={'_blank'}>
            {product.reserve_id}
          </a>
        </TableCell>
        <TableCell width={width[13]} center>
          {product.address}
        </TableCell>
        <TableCell width={width[11]}>
          <a href={TO_PRODUCT(product.warehouse_id)} target={'_blank'}>
            {product.name}
          </a>
        </TableCell>
        <TableCell width={width[4]} center>
          <Text fontWeight={600}>{product.reserved}</Text>
          {product.dereserved > 0 && (
            <Text style={{ color: 'red' }} fontWeight={500}>
              {' '}
              / ({-`${product.dereserved}`})
            </Text>
          )}
        </TableCell>
        <TableCell width={WIDTH_POSTING[11]}>
          <Column>
            <div className={styles.div_line}>
              <CommentPostingProductBlock
                posting={{ history: product.comments }}
                offer_id={product.id}
                isFilter={false}
                onChange={(v) => onChange(product._id, 'comment', v, 'add')}
                width={'230px'}
              />
            </div>
          </Column>
        </TableCell>

        {isAdmin && (
          <TableCell width={WIDTH_POSTING[11]}>
            <div className={styles.div_line}>
              <Button
                type={TYPE_BUTTONS.GREEN}
                style={{ marginRight: '15px' }}
                disabled={product.result?.is_closed}
                onClick={() => onChange(product._id, 'checkup_is_closed', true)}
              >
                Решено
              </Button>

              <PenaltyPopUp
                disabled={product.result?.is_closed}
                onChangeProduct={(data) => onChange(product._id, 'penalty', data)}
              />
            </div>
          </TableCell>
        )}
      </TableLine>
      {isOpenHistory && (
        <div className={styles.history_block}>
          {product.history.map((item) => (
            <WarehouseHistoryBlock part={item} key={item['_id']} />
          ))}
        </div>
      )}
    </>
  );
};

export default ReservesLine;
